import React from 'react';
import { HomePage } from './pages/HomePage';
import { SpecialistsPage } from './pages/SpecialistsPage';
import { CompaniesPage } from './pages/CompaniesPage';
export function App() {
  // Simple routing based on URL path
  const path = window.location.pathname;
  if (path === '/specialists') {
    return <SpecialistsPage data-id="element-0" />;
  }
  if (path === '/companies') {
    return <CompaniesPage data-id="element-1" />;
  }
  return <HomePage data-id="element-2" />;
}